import { GlobeIcon } from '@radix-ui/react-icons';
import { Flex, Select, Text } from '@radix-ui/themes';
import { useLanguage } from '../hooks';

import styles from './LanguageSwitcher.module.css';

export const LanguageSwitcher = () => {
    const { changeLanguage, currentLanguage, supportedLanguages } =
        useLanguage();

    return (
        <Select.Root
            value={currentLanguage?.code}
            onValueChange={changeLanguage}
        >
            <Select.Trigger
                className={styles.trigger}
                value={currentLanguage?.label}
                variant={'soft'}
                color={'gray'}
            >
                <Flex as='span' align='center' gap='2'>
                    <GlobeIcon />
                    <Text>{currentLanguage?.label}</Text>
                </Flex>
            </Select.Trigger>

            <Select.Content side='bottom' position='popper'>
                {supportedLanguages.map(({ code, label }) => (
                    <Select.Item key={code} value={code} textValue={label}>
                        <Text>{label}</Text>
                    </Select.Item>
                ))}
            </Select.Content>
        </Select.Root>
    );
};
